import { render, staticRenderFns } from "./FormControlModulecomponentsCategoryComponent.vue?vue&type=template&id=1472d904"
import script from "./FormControlModulecomponentsCategoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulecomponentsCategoryComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports